import React, { useState } from 'react';
import Icon from './Icon';
import symbolUrl from './symbolUrl';

export default function Collapse({trigger, open, children}) {
    const [isOpen, setIsOpen] = useState(open);

    return (
        <>
            <button
                className={`btn btn--collapse btn-block border-0 ${!isOpen ? 'collapsed' : ''}`}
                data-toggle="collapse"
                data-target={`#${trigger.replace(/[\W_]/g, '')}`}
                aria-expanded={isOpen ? 'true' : 'false'}
                aria-controls={trigger.replace(/[\W_]/g, '')}
                type="button"
                onClick={() => setIsOpen(!isOpen)}>
                <span className="btn--collapse__label">{trigger}</span>
                <Icon url={isOpen ? symbolUrl('min') : symbolUrl('plus')} size="12" classes="btn--collapse__icon" />
            </button>
            <div className={`collapse ${open ? 'show' : ''}`} id={trigger.replace(/[\W_]/g, '')}>
                <div className="collapse__wrapper">{children}</div>
            </div>
        </>
    );
}
